import { BaseService } from 'core/services';
import MissingDocumentRouteService from './MissingDocumentRouteService';

class MissingDocumentService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new MissingDocumentRouteService());
    }
}

export default MissingDocumentService;